module.exports = __webpack_public_path__ + "static/img/person.203422a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/person.png
// module id = Zziw
// module chunks = 3